/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/197-cloud-check': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.942 8.039a2.5 2.5 0 00-3.085-2.955 3 3 0 00-5.737.075A4 4 0 104 13h9.5a2.5 2.5 0 00.442-4.961zM6.5 12L4 9.5l1-1L6.5 10 10 6.5l1 1L6.5 12z"/>'
  }
})
